/**
 * File dialog.js.
 *
 * JS code to handle a11y dialog triggers.
 *
 */
import 'a11y-dialog';
import $ from 'jquery';

export function initA11yDialog() {
    window.jQuery = $;
    window.$ = $;

    $('.dialog--btn').on('click', function (e) {
        e.preventDefault();
        var dialog_to_open = '#' + $(this).data('a11y-dialog-show');
        $(dialog_to_open).attr('aria-hidden', false);
        $(dialog_to_open).trigger('focus');
    });

    $('.btn--close').on('click', function () {
        var parent_container = $(this).parent().parent().parent().parent();
        parent_container.attr('aria-hidden', true);
    });
}
